/**
 * The CP-1 zod schemas that the frozen file exports only as values (CapitalSnapshot, Equity, QuarterRecord, …),
 * re-exported WITH their TS type (ADR-0027 §4). Not frozen; the value is the same object and the type is exactly z.infer.
 * index.ts exports these names explicitly, which shadows the star export of the bare value.
 */
import type { z } from "zod";
import {
  Accounting as AccountingSchema, CapabilityParams as CapabilityParamsSchema,
  CapitalSnapshot as CapitalSnapshotSchema, CeclParams as CeclParamsSchema, CreditPdParams as CreditPdParamsSchema,
  CurvePoint as CurvePointSchema, DepositBetaParams as DepositBetaParamsSchema,
  DepositFlowParams as DepositFlowParamsSchema, Equity as EquitySchema, FeesParams as FeesParamsSchema,
  Finding as FindingSchema, FranchiseState as FranchiseStateSchema, HqlaLevel as HqlaLevelSchema,
  InvariantCheck as InvariantCheckSchema, IrrSnapshot as IrrSnapshotSchema, IsoDateTime as IsoDateTimeSchema,
  LiquiditySnapshot as LiquiditySnapshotSchema, LoanDemandParams as LoanDemandParamsSchema,
  LogitShareParams as LogitShareParamsSchema, MtmParams as MtmParamsSchema, OpexParams as OpexParamsSchema,
  PendingLaggedEffect as PendingLaggedEffectSchema, PeriodReport as PeriodReportSchema, PlayMode as PlayModeSchema,
  PrepayParams as PrepayParamsSchema, QuarterRecord as QuarterRecordSchema, RateType as RateTypeSchema,
  RollForward as RollForwardSchema, SecuritiesTrade as SecuritiesTradeSchema, SemVer as SemVerSchema,
  Sha256Hex as Sha256HexSchema, StatementSet as StatementSetSchema, UnderwritingParams as UnderwritingParamsSchema,
  Uuid as UuidSchema, ValuationAdjustment as ValuationAdjustmentSchema,
} from "./cp1_domain";

export const Accounting = AccountingSchema;
export type Accounting = z.infer<typeof AccountingSchema>;
export const CapabilityParams = CapabilityParamsSchema;
export type CapabilityParams = z.infer<typeof CapabilityParamsSchema>;
export const CapitalSnapshot = CapitalSnapshotSchema;
export type CapitalSnapshot = z.infer<typeof CapitalSnapshotSchema>;
export const CeclParams = CeclParamsSchema;
export type CeclParams = z.infer<typeof CeclParamsSchema>;
export const CreditPdParams = CreditPdParamsSchema;
export type CreditPdParams = z.infer<typeof CreditPdParamsSchema>;
export const CurvePoint = CurvePointSchema;
export type CurvePoint = z.infer<typeof CurvePointSchema>;
export const DepositBetaParams = DepositBetaParamsSchema;
export type DepositBetaParams = z.infer<typeof DepositBetaParamsSchema>;
export const DepositFlowParams = DepositFlowParamsSchema;
export type DepositFlowParams = z.infer<typeof DepositFlowParamsSchema>;
export const Equity = EquitySchema;
export type Equity = z.infer<typeof EquitySchema>;
export const FeesParams = FeesParamsSchema;
export type FeesParams = z.infer<typeof FeesParamsSchema>;
export const Finding = FindingSchema;
export type Finding = z.infer<typeof FindingSchema>;
export const FranchiseState = FranchiseStateSchema;
export type FranchiseState = z.infer<typeof FranchiseStateSchema>;
export const HqlaLevel = HqlaLevelSchema;
export type HqlaLevel = z.infer<typeof HqlaLevelSchema>;
export const InvariantCheck = InvariantCheckSchema;
export type InvariantCheck = z.infer<typeof InvariantCheckSchema>;
export const IrrSnapshot = IrrSnapshotSchema;
export type IrrSnapshot = z.infer<typeof IrrSnapshotSchema>;
export const IsoDateTime = IsoDateTimeSchema;
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;
export const LiquiditySnapshot = LiquiditySnapshotSchema;
export type LiquiditySnapshot = z.infer<typeof LiquiditySnapshotSchema>;
export const LoanDemandParams = LoanDemandParamsSchema;
export type LoanDemandParams = z.infer<typeof LoanDemandParamsSchema>;
export const LogitShareParams = LogitShareParamsSchema;
export type LogitShareParams = z.infer<typeof LogitShareParamsSchema>;
export const MtmParams = MtmParamsSchema;
export type MtmParams = z.infer<typeof MtmParamsSchema>;
export const OpexParams = OpexParamsSchema;
export type OpexParams = z.infer<typeof OpexParamsSchema>;
export const PendingLaggedEffect = PendingLaggedEffectSchema;
export type PendingLaggedEffect = z.infer<typeof PendingLaggedEffectSchema>;
export const PeriodReport = PeriodReportSchema;
export type PeriodReport = z.infer<typeof PeriodReportSchema>;
export const PlayMode = PlayModeSchema;
export type PlayMode = z.infer<typeof PlayModeSchema>;
export const PrepayParams = PrepayParamsSchema;
export type PrepayParams = z.infer<typeof PrepayParamsSchema>;
export const QuarterRecord = QuarterRecordSchema;
export type QuarterRecord = z.infer<typeof QuarterRecordSchema>;
export const RateType = RateTypeSchema;
export type RateType = z.infer<typeof RateTypeSchema>;
export const RollForward = RollForwardSchema;
export type RollForward = z.infer<typeof RollForwardSchema>;
export const SecuritiesTrade = SecuritiesTradeSchema;
export type SecuritiesTrade = z.infer<typeof SecuritiesTradeSchema>;
export const SemVer = SemVerSchema;
export type SemVer = z.infer<typeof SemVerSchema>;
export const Sha256Hex = Sha256HexSchema;
export type Sha256Hex = z.infer<typeof Sha256HexSchema>;
export const StatementSet = StatementSetSchema;
export type StatementSet = z.infer<typeof StatementSetSchema>;
export const UnderwritingParams = UnderwritingParamsSchema;
export type UnderwritingParams = z.infer<typeof UnderwritingParamsSchema>;
export const Uuid = UuidSchema;
export type Uuid = z.infer<typeof UuidSchema>;
export const ValuationAdjustment = ValuationAdjustmentSchema;
export type ValuationAdjustment = z.infer<typeof ValuationAdjustmentSchema>;
